import React, { Fragment, Component } from 'react'
import {
    Row, Col,Button, Label,Table
} from "reactstrap"
import classnames from 'classnames'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Link, Redirect } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'

import IndexBloc from '../../Index/Blocs/IndexBloc'
import UpdateBloc from '../../Update/Blocs/UpdateBloc'

class WewenangComponent extends Component {

    updateBloc = new UpdateBloc()
    indexBloc = new IndexBloc()
    source
    timer
    constructor(props) {
        super(props)
        this.state = {
            detail: [],
            detailWewenang: [
                {
                    id: 1,
                    desc: '',
                }
            ],
            dataForm: {},
            isLoading: 0,
        }
    }

    reformatAuth = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["id"] = data.authority_id;
          newObj["desc"] = data.authority_description;
          return newObj;
        });
    }

    toggle = tab => {
        if(this.state.activeTab !== tab) this.setState({activeTab:tab});
    }

    
    loaddetailWewenang = async () => {
        const query = {
            uuid: this.props.uuid
        }

        await this.updateBloc.fetchAuthority(query)
    }

    componentDidMount() {
        this.loaddetailWewenang()
        // console.log(this.state.detailWewenang)
        
        this.updateBloc.detailWewenangChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log('Wewenang')
                        console.log(response)
                        if (response.length > 0) {
                            this.setState({ detailWewenang: this.reformatAuth(response) })
                        }
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        

    }

    componentWillUnmount() {
        this.updateBloc.updateAuthorityChannel?.unsubscribe()
        this.updateBloc.detailWewenangChannel?.unsubscribe()
    }

    render() {
        const { detail, list } = this.state
        return (
            <Fragment>
                <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) => this.handlerOnSubmitAuth(e, values)}
                >
                    <Col md="12">
                            <div className="row" style={{padding:'15px'}}>
                                <div className="col-md-5 text-bold">
                                    <b>Wewenang</b>
                                </div>
                            </div>
                        </Col>
                    <Row className="mb-12">
                        <AvField
                            name="tipe"
                            type="hidden"
                            id="tipe"
                            value="1"
                        />
                        <Table className="table-bordered">
                            <thead className="bg-default" style={{background:'lavender'}}>
                                <tr>
                                    <th>Uraian Wewenang</th>
                                </tr>
                            </thead>
                            <tbody>
                                    {
                                this.state.detailWewenang.map((data, index) => {
                                    return (
                                <tr>
                                    <td>
                                        {data.desc}
                                    </td>
                                </tr>
                                               
                                    )    
                                })
                            }
                            </tbody>
                        </Table>
                        <AvField
                            name="authority_position_uuid"
                            type="hidden"
                            value={this.props.uuid}
                            // validate={{ required: { value: true } }}
                            readOnly={true}
                        />
                        
                    </Row>
                    <Row className="mb-3" style={{padding:'25px'}}>
                        <Col md="3"></Col>
                        <Col md="9">
                            <Link to="/master/syarat_jabatan.html">
                                <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                            </Link>
                            {' '}
                            
                        </Col>
                    </Row>
                </AvForm>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/syarat_jabatan.html'/>
                : null }
            </Fragment>
        )
    }


}

export default WewenangComponent
